import type { TenantProvisioningRetryDTO, TenantProvisioningStatusDTO } from '@today/types'
import { apiClient } from './api.client'

const base = (tenantId: string) => `/admin/tenants/${encodeURIComponent(tenantId)}/provisioning`

/** A tenant's provisioning status and retry (TO-375) — Super-Admin only. */
export const tenantProvisioningService = {
	/** `GET /admin/tenants/{tenantId}/provisioning`. */
	async getStatus(tenantId: string): Promise<TenantProvisioningStatusDTO> {
		const { data } = await apiClient.get<TenantProvisioningStatusDTO>(base(tenantId))
		return data
	},

	/** `POST /admin/tenants/{tenantId}/provisioning/retry` → 202. */
	async retry(tenantId: string): Promise<TenantProvisioningRetryDTO> {
		const { data } = await apiClient.post<TenantProvisioningRetryDTO>(`${base(tenantId)}/retry`)
		return data
	},
}
